// src/store/index.ts
import type { App } from 'vue'
import { createPinia } from 'pinia'

/** 单例 Pinia 实例，整个应用只生成一次 */
export const pinia = createPinia()
// 向旧代码兼容
export { pinia as store }
/**
 * 在 main.ts 调用，用来把 pinia 装到 app 上
 * @example
 *   import { setupStore } from '@/store'
 *   setupStore(app)
 */
export function setupStore(app: App<Element>) {
  app.use(pinia)
}